import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 pt-24 pb-16 md:pt-32 md:pb-24 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="relative mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 rounded-full mb-4 md:mb-6">
              <Icon name="Sparkles" size={16} color="var(--color-primary)" className="mr-2" />
              <span className="text-sm font-caption font-medium text-primary">Simple. Smart. Powerful.</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-secondary mb-4 md:mb-6 leading-tight">
              See All Your Money
              <span className="block text-primary mt-2">In One Clear View</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
              Rovyn Budget helps you control and understand your money—without complicated spreadsheets. Track income, expenses, and balances across all your accounts with confidence.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start mb-6 md:mb-8">
              <Button
                variant="default"
                size="lg"
                onClick={() => navigate('/register')}
                iconName="ArrowRight"
                iconPosition="right"
                className="min-h-[52px] md:min-h-[56px] px-6 md:px-8 text-base md:text-lg font-semibold"
              >
                Get Started Free
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/login')}
                iconName="LogIn"
                iconPosition="left"
                className="min-h-[52px] md:min-h-[56px] px-6 md:px-8 text-base md:text-lg font-semibold border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
              >
                Sign In
              </Button>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-4 md:gap-6 text-sm md:text-base">
              <div className="flex items-center gap-2">
                <Icon name="Check" size={18} color="var(--color-success)" strokeWidth={3} />
                <span className="text-muted-foreground font-caption">No credit card</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Check" size={18} color="var(--color-success)" strokeWidth={3} />
                <span className="text-muted-foreground font-caption">Free forever</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative bg-card rounded-2xl shadow-elevation-5 p-5 md:p-6 lg:p-8">
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary/20 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-accent/20 rounded-full blur-3xl"></div>
              
              <div className="relative space-y-4 md:space-y-5">
                <div className="flex items-center justify-between p-4 md:p-5 bg-success/10 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="TrendingUp" size={20} color="var(--color-success)" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-muted-foreground font-caption">Total Income</p>
                      <p className="text-lg md:text-xl font-heading font-bold text-success">$8,450.00</p>
                    </div>
                  </div>
                  <Icon name="ArrowUpRight" size={18} color="var(--color-success)" />
                </div>

                <div className="flex items-center justify-between p-4 md:p-5 bg-error/10 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-error/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="TrendingDown" size={20} color="var(--color-error)" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-muted-foreground font-caption">Total Expenses</p>
                      <p className="text-lg md:text-xl font-heading font-bold text-error">$5,230.00</p>
                    </div>
                  </div>
                  <Icon name="ArrowDownRight" size={18} color="var(--color-error)" />
                </div>

                <div className="flex items-center justify-between p-4 md:p-5 bg-primary/10 rounded-xl">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="Wallet" size={20} color="var(--color-primary)" />
                    </div>
                    <div>
                      <p className="text-xs md:text-sm text-muted-foreground font-caption">Net Balance</p>
                      <p className="text-lg md:text-xl font-heading font-bold text-primary">$3,220.00</p>
                    </div>
                  </div>
                  <Icon name="Check" size={18} color="var(--color-primary)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;